export const css = {
    root: '_2ARhIxFg',
    copyright: 'NQsSev8d',
    selector: 'vc5aC-rL',
    privacypolicy: '_281GNCnG',
    disclaimer: '_1W4h58cp',
    alt: '_1Xjhrm0D',
    alt_img: 'OZZz3pps',
    alt_disclaimer: '_1y4TsxeM',
    ' _key': 'apic-theme/apic/micro/lcc-app/footer'
};
export default css;
